export default __webpack_public_path__ + "static/media/DSC_0634.361b7b0b.JPG";